import React, { createContext, useContext, useRef } from "react"
import { create, useStore } from "zustand"
import { chPsychologicalPsychoTherapyFragment$key } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/chPsychologicalPsychoTherapyFragment.graphql"

type State = {
  psychologicalPsychotherapyId: string | null
  psychologicalPsytherapyRef: chPsychologicalPsychoTherapyFragment$key | null
}

type Actions = {
  setPsychologicalPsytherapy: (
    therapyPrescriptionId: string | null,
    ref: chPsychologicalPsychoTherapyFragment$key | null,
  ) => void
  reset: () => void
}

const initialState: State = {
  psychologicalPsychotherapyId: null,
  psychologicalPsytherapyRef: null,
}

const createPsychologicalPsytherapyStore = () => {
  return create<State & Actions>((set) => ({
    ...initialState,
    setPsychologicalPsytherapy: (psychologicalPsychotherapyId, ref) =>
      set({ psychologicalPsychotherapyId, psychologicalPsytherapyRef: ref }),
    reset: () => {
      set(initialState)
    },
  }))
}

type PsychologicalPsytherapyStoreType = ReturnType<typeof createPsychologicalPsytherapyStore>

const PsychologicalPsytherapyStoreContext = createContext<PsychologicalPsytherapyStoreType | null>(null)

type PsychologicalPsytherapyStoreProviderProps = React.PropsWithChildren

export const PsychologicalPsytherapyStoreProvider = ({ children }: PsychologicalPsytherapyStoreProviderProps) => {
  const storeRef = useRef<PsychologicalPsytherapyStoreType>(undefined)
  if (!storeRef.current) {
    storeRef.current = createPsychologicalPsytherapyStore()
  }
  return (
    <PsychologicalPsytherapyStoreContext.Provider value={storeRef.current}>
      {children}
    </PsychologicalPsytherapyStoreContext.Provider>
  )
}

export function usePsychologicalPsytherapyStoreContext<T>(selector: (state: State & Actions) => T): T {
  const store = useContext(PsychologicalPsytherapyStoreContext)
  if (!store) throw new Error("Missing PsychologicalPsytherapyStoreProvider in the tree")
  return useStore(store, selector)
}
